import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { RimResponse, Departments, UploadDelete, EntireUserDetails, userDetails, ExpenseItems, ListDepartments, statusApproval } from './reimbursement.interfaces';
import { map, publishReplay, refCount } from 'rxjs/operators';

@Injectable()

export class ReimbursementService {
  reimbursementUserList;
  public approval: boolean;
  public rejectApprovalCost: boolean;
  name: Observable<Departments>
  categoryName: Observable<Departments>
  statusName: Observable<ListDepartments[]>
  constructor(
    private http: HttpClient
  ) { }

  getHeaders() {
    return new HttpHeaders({
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'uid': localStorage.getItem('uid'),
      'clientid': localStorage.getItem('client_id')
    });
  }

  getUser(data, statusKey): Observable<RimResponse> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements?status=${statusKey}`;
    return this.http.post<RimResponse>(requestUrl, data, { headers: headers });
  }

  getSaveUser(data): Observable<RimResponse> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements`;
    return this.http.post<RimResponse>(requestUrl, data, { headers: headers });
  }

  getDepartments(): Observable<any> {
    if (!this.name) {
      const headers = this.getHeaders();
      const requestUrl = `${environment.rim_url}departments`;
      this.name = this.http.get(requestUrl, { headers: headers })
        .pipe(map(response => response['departments']), publishReplay(1), refCount());
    }
    return this.name;
  }

  getCategories(): Observable<any> {
    if (!this.categoryName) {
      const headers = this.getHeaders();
      const requestUrl = `${environment.rim_url}categories`;
      this.categoryName = this.http.get(requestUrl, { headers: headers })
        .pipe(map(response => response['categories']), publishReplay(1), refCount());
    }
    return this.categoryName;
  }

  getListStatus(): Observable<ListDepartments[]> {
    if (!this.statusName) {
      const headers = this.getHeaders();
      const requestUrl = `${environment.rim_url}status`;
      this.statusName = this.http.get<ListDepartments[]>(requestUrl, { headers: headers })
        .pipe(map(response => response['status']), publishReplay(1), refCount());
    }
    return this.statusName;
  }

  getUploadFile(files): Observable<any> {
    let headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}attachments`;
    return this.http.post(requestUrl, files, { headers: headers })
      .pipe(map(response => response['attachments']));
  }

  deleteUploadFile(keyValue): Observable<UploadDelete> {
    const httpOptions = {
      headers: this.getHeaders(), body: { key: keyValue }
    };
    const requestUrl = `${environment.rim_url}attachments`;
    return this.http.delete<UploadDelete>(requestUrl, httpOptions);
  }

  getEntireUserDetails(pageNo): Observable<EntireUserDetails> {
    let headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements?page=${pageNo}`;
    return this.http.get<EntireUserDetails>(requestUrl, { headers: headers })
  }

  getUserExpensesItems(id): Promise<any> {

    let promise = new Promise((resolve, reject) => {
      
      let headers = this.getHeaders();
      const requestUrl = `${environment.rim_url}reimbursements/` + id;
      this.http.get<userDetails>(requestUrl, { headers: headers })
        .toPromise()
        .then(
          res => {
            resolve(res['reimbursement']);
          },
          msg => {
            reject(msg);
      });
    });
    return promise;
  }

  updateUser(data, id, statusKey): Observable<RimResponse> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements/` + id + '?status=' + statusKey;
    return this.http.put<RimResponse>(requestUrl, data, { headers: headers });
  }

  updateSaveUser(data, id): Observable<RimResponse> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements/` + id;
    return this.http.put<RimResponse>(requestUrl, data, { headers: headers });
  }

  deleteUser(id) {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reimbursements/` + id;
    return this.http.delete<RimResponse>(requestUrl, { headers: headers });
  }

  getManagerList(pageNo, filterDate, emp_Id, status_Id): Observable<ExpenseItems> {
    const headers = this.getHeaders();
    let requestUrl = `${environment.rim_url}team_reimbursements?`;
    let params = (pageNo) ? `page=${pageNo}` : '&page=1';
    params += (filterDate) ? (filterDate) : '';
    params += (emp_Id) ? `&emp_id=${emp_Id}` : '';
    params += (status_Id) ? `&status=${status_Id}` : '';
    return this.http.get<ExpenseItems>(requestUrl + params, { headers: headers })
  }

  getAdminList(pageNo, filterDate, emp_Id, status_Id) {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}admin_reimbursements?`;
    let params = (pageNo) ? `page=${pageNo}` : '&page=1';
    params += (filterDate) ? (filterDate) : '';
    params += (emp_Id) ? `&emp_id=${emp_Id}` : '';
    params += (status_Id) ? `&status=${status_Id}` : '';
    return this.http.get<ExpenseItems>(requestUrl + params, { headers: headers })
  }

  getApproval(payload, id, statusKey): Observable<statusApproval> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}team_reimbursements/` + id + '?status=' + statusKey;
    return this.http.patch<statusApproval>(requestUrl, payload, { headers: headers })
  }

  getRejected(payload, id, rejectedKey): Observable<statusApproval> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}team_reimbursements/` + id + '?status=' + rejectedKey;
    return this.http.patch<statusApproval>(requestUrl, payload, { headers: headers })
  }
  getAccept(payload, id, acceptedKey): Observable<statusApproval> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}team_reimbursements/` + id + '?status=' + acceptedKey;
    return this.http.patch<statusApproval>(requestUrl, payload, { headers: headers })
  }
  getReportFile(id) {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reports/reimbursements/` + id;
    return this.http.get(requestUrl, { headers: headers, responseType: 'blob' });
  }

  getReport(id) {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reports/reimbursements/` + id + '?details=false';
    return this.http.get(requestUrl, { headers: headers, responseType: 'blob' });
  }
  getExportCsv(dateQuery) {
    const headers = this.getHeaders();
    const requestUrl = `${environment.rim_url}reports/?` + dateQuery;
    return this.http.get(requestUrl, { headers: headers, responseType: 'blob' });
  }
}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement.service.ts